import React, { useState } from 'react'
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react'
import classNames from 'classnames'
import type { SwiperClass } from 'swiper/react'

import { usePage } from '~/hooks'
import { Button } from '../Button'
import Carousel from '../Carousel'
import { ProductCard } from '../ProductCard'
import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './CartUpsellProductSlider.module.css'
import { CartUpsellProductSliderProps } from './CartUpsellProductSlider.types'

export const CartUpsellProductSlider = ({
  title,
  products,
}: CartUpsellProductSliderProps) => {
  const [swiper, setSwiper] = useState<SwiperClass>(null)
  const page = usePage()
  const isRTM = page.brand === 'rtm'
  const firstTwoProducts = 2

  return (
    <div
      className={classNames(styles.root, {
        'p-4 pr-0 rounded-md': !isRTM,
      })}>
      <div className='flex justify-between mb-2 items-center'>
        <Typography
          variant={TypographyVariant.BodyLargeBold}
          tag={TypographyTag.div}
          className='text-secondary-muted'>
          {title}
        </Typography>
        {products?.length > firstTwoProducts && (
          <div className={classNames('flex gap-1', { 'pr-4': !isRTM })}>
            <Button
              iconOnly
              onClick={() => {
                swiper.slidePrev()
              }}
              size='sm'
              shape='circle'
              variant='ghost'
              icon={<IconChevronLeft />}
              style={{
                '--btn-size-sm-height': '32px',
                '--btn-icon-size': '16px',
              }}
            />

            <Button
              iconOnly
              onClick={() => {
                swiper.slideNext()
              }}
              size='sm'
              shape='circle'
              variant='ghost'
              icon={<IconChevronRight />}
              style={{
                '--btn-size-sm-height': '32px',
                '--btn-icon-size': '16px',
              }}
            />
          </div>
        )}
      </div>
      <Carousel.Container
        onSwiper={(sw) => {
          setSwiper(sw)
        }}
        slidesPerView='auto'
        spaceBetween={16}
        wrapperClass='!justify-start'>
        {products.map((product) => {
          return (
            <Carousel.Slide
              key={product.title}
              className='!h-auto max-w-[164px]'>
              <ProductCard
                className='bg-white'
                titleClass='!text-sm !leading-4'
                {...product}
                showAddToCartButton
                showCompactAddToCart={false}
                titleSection={title}
                isUpsell
              />
            </Carousel.Slide>
          )
        })}
      </Carousel.Container>
    </div>
  )
}
